import VideoStatusUsingAPI from "./NvcryptStatus";

export default function ({
  videoId,
  platform,
  history_id,
  videoRef,
  setVideoRef,
  videoContainerRef,
  dispatch,
  state
}) {
  return (
    <div className={`h-full ${platform !== "nvcrypt" && "hidden"}`}>
      <VideoStatusUsingAPI
        videoId={videoId}
        history_id={history_id}
        videoRef={videoRef}
        setVideoRef={setVideoRef}
        isAPIReady={true}
        dispatch={dispatch}
        state={state}
      />
      <div
        className={`vdo-container h-full w-full`}
        ref={videoContainerRef}
      ></div>
    </div>
  );
}
